export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9664.7aed9585.jpg";